"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIBreadcrumbs;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIDropdown = _interopRequireDefault(require("../dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("../list/UIList"));

var _decorators = require("../utils/propTypes/decorators");

var _devWarnings = require("../utils/devWarnings");

var renderBreadcrumb = function renderBreadcrumb(children, hasArrow, isBackLink) {
  return _react.default.createElement("span", null, hasArrow && _react.default.createElement(_UIIcon.default, {
    className: (0, _classnames.default)('private-breadcrumbs__arrow', {
      'private-breadcrumbs__arrow--back': isBackLink
    }),
    name: isBackLink ? 'left' : 'right'
  }), children);
};

var renderChild = function renderChild(child, index, totalCrumbs) {
  var isOnlyChild = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var singleBreadcrumbIsBackLink = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isSROnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var ariaCurrent = !isOnlyChild && index === totalCrumbs - 1 ? 'location' : null;
  var isBackLink = isOnlyChild && singleBreadcrumbIsBackLink;
  var hasArrow = isBackLink || index !== 0;
  var addedClassNames = (0, _classnames.default)('private-breadcrumbs__item', {
    'sr-only sr-only-focusable': isSROnly
  });
  (0, _devWarnings.warnIfFragment)(child, 'UIBreadcrumbs');

  if ((0, _react.isValidElement)(child)) {
    return (0, _react.cloneElement)(child, {
      'aria-current': ariaCurrent,
      children: renderBreadcrumb(child.props.children, hasArrow, isBackLink),
      key: index,
      className: addedClassNames
    });
  }

  return _react.default.createElement("span", {
    "aria-current": ariaCurrent,
    className: addedClassNames
  }, renderBreadcrumb(child, hasArrow, isBackLink));
};

var renderTruncateDropdown = function renderTruncateDropdown(children, defaultOpen) {
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIIcon.default, {
    className: "private-breadcrumbs__arrow",
    name: "right"
  }), _react.default.createElement(_UIDropdown.default, {
    autoPlacement: "vert",
    tabIndex: -1,
    buttonUse: "transparent",
    buttonText: _react.default.createElement("span", {
      className: "align-center"
    }, _react.default.createElement(_UIIcon.default, {
      name: "ellipses",
      className: "m-right-0 m-left-1 m-top-1",
      size: 22
    })),
    buttonClassName: "p-x-0",
    caretRenderer: function caretRenderer() {
      return null;
    },
    defaultOpen: defaultOpen,
    menuWidth: "auto",
    placement: "bottom right"
  }, _react.default.createElement(_UIList.default, null, children)));
};

var renderTruncatedBreadcrumbs = function renderTruncatedBreadcrumbs(validChildren, isOnlyChild, singleBreadcrumbIsBackLink, levelsToShow, defaultOpen) {
  var totalCrumbs = validChildren.length;
  var innerCrumbs = validChildren.slice(1, -levelsToShow);
  var innerCrumbLength = innerCrumbs.length;
  var updatedLevelsToShow = innerCrumbLength ? levelsToShow : totalCrumbs - 1;
  return _react.default.createElement(_react.Fragment, null, renderChild(validChildren[0], 0, totalCrumbs, isOnlyChild, singleBreadcrumbIsBackLink), innerCrumbs.map(function (child, index) {
    return renderChild(child, index + 1, totalCrumbs, isOnlyChild, singleBreadcrumbIsBackLink, true);
  }), innerCrumbLength ? renderTruncateDropdown(innerCrumbs, defaultOpen) : null, validChildren.map(function (child, index) {
    if (index > totalCrumbs - updatedLevelsToShow - 1) {
      return renderChild(child, index, totalCrumbs, isOnlyChild, singleBreadcrumbIsBackLink);
    }

    return null;
  }));
};

var renderChildren = function renderChildren(children, singleBreadcrumbIsBackLink, truncateToLevels, defaultOpen) {
  var isValidChild = function isValidChild(child) {
    if (typeof child === 'string') {
      return child.trim().length > 0;
    }

    return child;
  };

  var childrenArray = _react.default.Children.toArray(children);

  var validChildren = childrenArray.filter(isValidChild);
  var totalCrumbs = validChildren.length;
  var isOnlyChild = totalCrumbs === 1;
  var breadcrumbs;

  if (truncateToLevels !== null && !isOnlyChild) {
    breadcrumbs = renderTruncatedBreadcrumbs(validChildren, isOnlyChild, singleBreadcrumbIsBackLink, truncateToLevels, defaultOpen);
  } else {
    breadcrumbs = _react.Children.map(validChildren, function (child, index) {
      return renderChild(child, index, totalCrumbs, isOnlyChild, singleBreadcrumbIsBackLink);
    });
  }

  if (isOnlyChild && !singleBreadcrumbIsBackLink) {
    breadcrumbs.push(_react.default.createElement("span", {
      className: "private-breadcrumbs__item",
      key: "x"
    }, renderBreadcrumb(null, true, false)));
  }

  return breadcrumbs;
};

function UIBreadcrumbs(props) {
  var className = props.className,
      children = props.children,
      flush = props.flush,
      singleBreadcrumbIsBackLink = props.singleBreadcrumbIsBackLink,
      truncateToLevels = props.truncateToLevels,
      wrapLevels = props.wrapLevels,
      defaultOpen = props.defaultOpen,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "children", "flush", "singleBreadcrumbIsBackLink", "truncateToLevels", "wrapLevels", "defaultOpen"]);
  return _react.default.createElement("nav", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-breadcrumbs', className, {
      'private-breadcrumbs--flush': flush,
      'private-breadcrumbs--no-wrap': !(wrapLevels || truncateToLevels !== null)
    })
  }), renderChildren(children, singleBreadcrumbIsBackLink, truncateToLevels, defaultOpen));
}

UIBreadcrumbs.propTypes = {
  children: _propTypes.default.node,
  defaultOpen: (0, _decorators.hidden)(_propTypes.default.bool.isRequired),
  flush: _propTypes.default.bool.isRequired,
  singleBreadcrumbIsBackLink: _propTypes.default.bool.isRequired,
  truncateToLevels: _propTypes.default.number,
  wrapLevels: _propTypes.default.bool.isRequired
};
UIBreadcrumbs.defaultProps = {
  defaultOpen: false,
  flush: false,
  role: 'navigation',
  singleBreadcrumbIsBackLink: true,
  truncateToLevels: null,
  wrapLevels: false
};
UIBreadcrumbs.displayName = 'UIBreadcrumbs';
module.exports = exports.default;